import React from "react";
import { graphql, compose } from "react-apollo";

import pauseIcon from "assets/img/pause-button.svg";
import continueIcon from "assets/img/continue-button.svg";

import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext";
import translateErrorMessage from "utils/translateErrorMessage";

import PAUSE_PROCESS_MUTATION from "./graphql/pauseProcessMutation";
import ActionButton from "./ActionButton";

const PauseButton = ({
  automationStatus,
  hasShipment,
  pauseShipment,
  snackbarContext,
}) => {

  const paused = automationStatus && automationStatus.currentAutomationStatus && automationStatus.currentAutomationStatus.status === "PAUSED";

  const {
    icon,
    label,
    action,
    message,
  } = paused
    ? {
      label: "Continuar",
      action: "continuar",
      message: "O carregamento está em progresso...",
      icon: continueIcon,
    }
    : {
      label: "Pausar",
      action: "pausar",
      message: "O carregamento foi pausado",
      icon: pauseIcon,
    };

  const onConfirm = () => {
    pauseShipment({
      variables: {
        status: !paused,
      },
      refetchQueries: []
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, message);
      })
      .catch((error) => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };

  return (
    <ActionButton
      icon={icon}
      label={label}
      onConfirm={onConfirm}
      classes="pause"
      action={action}
      active={paused}
      disabled={!hasShipment}
    />
  );
};

export default compose(
  withSnackbarConsumer,
  graphql(PAUSE_PROCESS_MUTATION, { name: "pauseShipment" }),
)(PauseButton);
